const imagesUrlPrefix = 'https://cdn.jsdelivr.net/gh/db-cheppie/assets/images/'

const images = {
  darkLogo: `${imagesUrlPrefix}darkLogo.svg`,
  favicon: `${imagesUrlPrefix}favicon.png`,
  logo: `${imagesUrlPrefix}logo.svg`
}

export default images
